import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { ContextAccount } from "../../../libs/context-account"
import { User } from "../../../rpcs/dist/UserRPC"
import Color from "../../../style/enum/color"
import { UserIcon } from "../user-icon"
// import { FollowButton } from "../buttons/follow-button"

interface IProps {
  user: User
}

export const UserListItem = ({ user }: IProps) => {
  const ca = new ContextAccount(user)
  return (
    <Wrapper to={ca.getAccountUrl()}>
      <UserIcon size={50} title={"ユーザー"} url={user.profileImage.square} />
      <Information>
        <Name>{user.screenName}</Name>
        <ID>@{user.name}</ID>
      </Information>
      <Description>{user.description}</Description>
    </Wrapper>
  )
}

const Wrapper = styled(Link)`
  border-bottom: 1px solid ${Color.LIGHT_GRAY};
  margin-bottom: -1px;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
`

const Information = styled.div`
  flex-grow: 1;
  margin-left: 7px;
  line-height: 1.2;
`

const Description = styled.div`
  width: 100%;
  font-size: 0.8rem;
  color: ${Color.DIMGRAY};
  margin-top: 15px;
`

const Name = styled.div`
  color: ${Color.BLACK};
  margin-top: 8px;
`

const ID = styled.div`
  color: ${Color.DIMGRAY};
  font-size: 0.8rem;
`
